export default "__VITE_ASSET__BWwC1vOm__"